import axios from 'axios';
import Common from './Common';
export default {
    getDashboard(id,i){
        return axios.get(Common.api + 'buyer-dashboard/'+id+'/'+i);
    },
    getBudgetRange(id){
        return axios.get(Common.api + 'get-range/' + id);
    },
    createResgistration2(data){
        return axios.post(Common.api + 'buyer-reg-second', data);
    },
    update(id,data){
        return axios.put(Common.api+'seller-login'+id,data);
    }
}